(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    const addKlarnaCheckoutLinks = (root = document) => {
    const productDetails = [];

    if (root.matches?.('.product-details[data-financing-checkout-url]')) productDetails.push(root);
    productDetails.push(...root.querySelectorAll?.('.product-details[data-financing-checkout-url]') ?? []);

    productDetails.forEach((details) => {
      const checkoutUrl = details.dataset.financingCheckoutUrl;
      if (!checkoutUrl) return;

      details.querySelectorAll('.shopify-app-block').forEach((card) => {
        if (!card.querySelector('klarna-placement')) return;
        if (card.querySelector(':scope > .financing-checkout-overlay')) return;

        const link = document.createElement('a');
        link.className = 'financing-checkout-overlay';
        link.href = checkoutUrl;
        link.setAttribute('aria-label', details.dataset.financingCheckoutLabel || 'Go to checkout with Klarna');
        card.append(link);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => addKlarnaCheckoutLinks(), { once: true });
  } else {
    addKlarnaCheckoutLinks();
  }

  document.addEventListener('shopify:section:load', (event) => addKlarnaCheckoutLinks(event.target));
  } catch(e) { console.error(e); }
})();

})();
